<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import { Holiday } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import HolidayForm from './HolidayForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import { today, getLocalTimeZone } from '@internationalized/date';

    const form = useForm({
        name: '',
        holiday_date: today(getLocalTimeZone()).toString(),
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.salary.holidays.store')"
        :query-key="[QueryKey.HOLIDAYS]"
        title="holidays.create"
        button-text="holidays.create"
    >
        <HolidayForm :form="form" />
    </DialogForm>
</template>
